
export class MeddelandeInfotavlaDTO   {

    id: number;
    datumFran: string;
    datumTill: string;
    rubrik: string;
    meddelande: string;
    iBy: string;
    iDate: string;
    rowVersion: number[];

    constructor() {
        this.id = undefined;
        this.datumFran = undefined;
        this.datumTill = undefined;
        this.rubrik = undefined;
        this.meddelande = undefined;
        this.iBy = undefined;
        this.iDate = undefined;
        this.rowVersion = undefined;
    }
}
